import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeInputTransPage } from '../../../../redux/actions/pages/trans';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, TRANS_LIST_GET, GET_CASHIERS_OF_BRANCH, PRINT_TRANS_EXTERNAL_LINK, EXCEL_EXPORT_EXTERNAL_LINK, PDF_EXPORT_EXTERNAL_LINK } from '../../../../apis';
import axios from "axios";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { handleChangeDataModalTransDetails } from '../../../../redux/actions/partials/modals/modalTransDetails';
import { handleChangeDataModalEditTransFactorNum } from '../../../../redux/actions/partials/modals/modalEditTransFactorNum'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";


const Trans = () => {

	const dispatch = useDispatch();


	const { token, profile } = useSelector(state => state.login);
    const { trans, title, fromDate, startTime, toDate, endTime, cashierOptions, cashierSelect, branchOptions, branchSelect } = useSelector(state => state.trans);

    

    useEffect(() => {
        callApiGetTrans();
        // eslint-disable-next-line
    }, [Trans]);


    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);

    const [time, setTime] = useState(null);


    const callApiGetTrans = (event) => {
        if(event !== undefined)
            event.preventDefault();
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'get',
            url: BASE_SITE + TRANS_LIST_GET,
            params: {from_date: fromDate, to_date: toDate, start_time: startTime, end_time: endTime, cashier: cashierSelect, branch: branchSelect},
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                    break;
                case 'ok':
                    dispatch(handleChangeInputTransPage('trans', response.data.trans));
                    dispatch(handleChangeInputTransPage('branchOptions', response.data.branch_options));
                    dispatch(handleChangeInputTransPage('cashierOptions', response.data.cashier_options));
                    dispatch(handleChangeInputTransPage('title', response.data.title));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            dispatch(handleSetBackdropLoading(false));
        });
    };


    const callApiGetCashiers = (branch_value) => {
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'get',
            url: BASE_SITE + GET_CASHIERS_OF_BRANCH,
            params: {branch: branch_value},
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                    break;
                case 'ok':
                    dispatch(handleChangeInputTransPage('cashierOptions', response.data.cashier_options));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            dispatch(handleSetBackdropLoading(false));
        });
    };


    const showModalDetails = (key) => {
        dispatch(handleChangeDataModalTransDetails('isOpen', true));
        dispatch(handleChangeDataModalTransDetails('data', trans[key]));
    };

    const showModalEditFactorNum = (key) => {
        dispatch(handleChangeDataModalEditTransFactorNum('isOpen', true));
        dispatch(handleChangeDataModalEditTransFactorNum('transNum', trans[key].id));
        dispatch(handleChangeDataModalEditTransFactorNum('transKey', key));
    };


    const handleExportExcel = () => {
    	window.open(`${EXCEL_EXPORT_EXTERNAL_LINK}${token}?from_date=${fromDate}&to_date=${toDate}&start_time=${startTime}&end_time=${endTime}`, "_blank");
    };

    const handleExportPdf = () => {
    	window.open(`${PDF_EXPORT_EXTERNAL_LINK}${token}?from_date=${fromDate}&to_date=${toDate}&start_time=${startTime}&end_time=${endTime}`, "_blank");
    };


    const handleStartTimeChange = (selectedDates) => {
        if (selectedDates.length > 0) {
            const date = selectedDates[0];
            const formattedTime = date.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false, // برای نمایش ۲۴ ساعته
            });

            dispatch(handleChangeInputTransPage('startTime', formattedTime)); 
        }
    };

    const handleEndTimeChange = (selectedDates) => {
        if (selectedDates.length > 0) {
            const date = selectedDates[0];
            const formattedTime = date.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false, // برای نمایش ۲۴ ساعته
            });

            dispatch(handleChangeInputTransPage('endTime', formattedTime)); 
        }
    };

    const handleChangeCashier = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputTransPage(name, value));
    };


    const handleChangeBranch = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputTransPage(name, value));

        if(value !== '0')
            callApiGetCashiers(value);
        else {
            dispatch(handleChangeInputTransPage('cashierOptions', []));
            dispatch(handleChangeInputTransPage('cashierSelect', null));
        }
    };



    const DatePickerInput = (props) => {
        return <input className="popo" {...props} />;
    };

    const changeFromDate = (unix, formatted) => {
       dispatch(handleChangeInputTransPage('fromDate', formatted)); 
    };

    const changeToDate = (unix, formatted) => {
       dispatch(handleChangeInputTransPage('toDate', formatted)); 
    };


    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row>
                        <Col className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">لیست تراکنش ها{title} </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className="icon-minus4"></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                            <li><a onClick={handleExportExcel} href="#!" id="icon-excel" title="خروجی اکسل"><i className="icon-file-excel"></i></a></li>
                        					<li><a onClick={handleExportPdf} href="#!" id="icon-pdf" title="خروجی پی دی اف" target="_blank"><i className="icon-file-pdf"></i></a></li>
                                            <li><a onClick={() => setIsSearchVisible(! isSearchVisible)}><i className="icon-search"></i></a></li>
                                            <li><a onClick={() => callApiGetTrans()} title="رفرش"><i className="icon-reload" style={{color: '#0100fe'}}></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body collapse in">

                                    {isSearchVisible && (
                                    <motion.div 
                                        className="card-block" id="div-search"
                                        initial={{ opacity: 0, height: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, height: "auto", scale: 1 }}
                                        exit={{ opacity: 0, height: 0, scale: 0.8 }}
                                        transition={{ duration: 0.5, ease: "easeOut" }} >
                                        <form onSubmit={callApiGetTrans} >
                                            <div className="form-body" style={{overflow: 'unset !important'}} >
                                                <Row className="row">
                                                    <div style={{display: 'flex', justifyContent: 'flex-start'}}>
                                                        <div>

                                                            { profile.type !== 'cashier' ?
                                                            <>
                                                            <DatePicker
                                                                icon="fa fa-calendar"
                                                                inputComponent={DatePickerInput}
                                                                placeholder="از تاریخ"
                                                                format="jYYYY/jMM/jDD"
                                                                id="datePicker"
                                                                preSelected={""}
                                                                value={fromDate}
                                                                onChange={changeFromDate}
                                                                cancelOnBackgroundClick={true}
                                                                containerClass={"form-group col-md-3 col-xl-2 date-picker pos-initial"}
                                                            />
                                                            <input type="hidden" name="from_date" value={fromDate} />

                                                            <Col className="form-group col-md-3 col-xl-2 ">
                                                                <Flatpickr
                                                                        value={startTime}
                                                                        onChange={handleStartTimeChange}
                                                                        options={{
                                                                            enableTime: true,
                                                                            noCalendar: true,
                                                                            dateFormat: "H:i",
                                                                            time_24hr: true,
                                                                        }}
                                                                        className="input-style form-control"
                                                                        placeholder="از ساعت"
                                                                />
                                                            </Col>


                                                            <DatePicker
                                                                icon="fa fa-calendar"
                                                                inputComponent={DatePickerInput}
                                                                placeholder="تا تاریخ"
                                                                format="jYYYY/jMM/jDD"
                                                                id="datePicker"
                                                                preSelected={""}
                                                                value={toDate}
                                                                onChange={changeToDate}
                                                                cancelOnBackgroundClick={true}
                                                                containerClass={"form-group col-md-3 col-xl-2 date-picker pos-initial"}
                                                            />
                                                            <input type="hidden" name="to_date" value={toDate} />

                                                            <Col className="form-group col-md-3 col-xl-2 ">
                                                                <Flatpickr
                                                                        value={endTime}
                                                                        onChange={handleEndTimeChange}
                                                                        options={{
                                                                            enableTime: true,
                                                                            noCalendar: true,
                                                                            dateFormat: "H:i",
                                                                            time_24hr: true,
                                                                        }}
                                                                        className="input-style form-control"
                                                                        placeholder="تا ساعت"
                                                                />
                                                            </Col>
                                                            {
                                                                profile.type === 'manager' ? 
                                                                    <>
                                                                    <Col className="form-group col-md-3 col-xl-2 ">
                                                                        <select name="branchSelect" value={branchSelect} className="input-style form-control" onChange={handleChangeBranch}>
                                                                        { 
                                                                            branchOptions.map((branch, key) => {
                                                                                return (
                                                                                    <option value={branch.id} key={key}>{branch.title}</option>
                                                                                );
                                                                            })

                                                                        }
                                                                        </select>
                                                                    </Col>
                                                                    <Col className="form-group col-md-3 col-xl-2 ">
                                                                        <select name="cashierSelect" value={cashierSelect} className="input-style form-control" onChange={handleChangeCashier}>
                                                                        { 
                                                                            cashierOptions.map((cashier, key) => {
                                                                                return (
                                                                                    <option value={cashier.id}>{cashier.title}</option>
                                                                                );
                                                                            })

                                                                        }
                                                                        </select>
                                                                    </Col>
                                                                    </>
                                                                : profile.type === 'financial' ?
                                                                    <Col className="form-group col-md-3 col-xl-2 ">
                                                                        <select name="cashierSelect" value={cashierSelect} className="input-style form-control" onChange={handleChangeCashier}>
                                                                        { 
                                                                            cashierOptions.map((cashier, key) => {
                                                                                return (
                                                                                    <option value={cashier.id}>{cashier.title}</option>
                                                                                );
                                                                            })

                                                                        }
                                                                        </select>
                                                                    </Col>
                                                                :''
                                                            }
                                                            </>
                                                            : profile.type == 'financial' ?
                                                            <Col className="form-group col-md-3 col-xl-2 ">

                                                            </Col>
                                                            :''
                                                            }
                                                            <Col className="form-group col-md-3 col-xl-2 ">
                                                                <button type="submit" id="btn-search" className="btn btn-success w-100" name="search_btn" value="search" >
                                                                    <i className="icon-search"></i> جستجو 
                                                                </button>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </Row>
                                            </div>
                                        </form>
                                    </motion.div>
                                    )}

                                    <div className="table-responsive">
                                        <table className="table mb-0 table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{width: '1%'}} >#</th>
                                                    <th>شماره پیگیری</th>
                                                    <th>شماره فاکتور فروشگاه</th>
                                                    <th>موبایل کاربر</th>
                                                    <th>تاریخ تراکنش</th>
                                                    <th>مبلغ تراکنش</th>
                                                    <th>عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    trans.map((transItem, key) => {
                                                        return(
                                                            <tr>
                                                                <td> {key + 1} </td>
                                                                <td> {transItem.tracking_num} </td>
                                                                <td> {transItem.factor_num} </td>
                                                                <td> {transItem.mobile} </td>
                                                                <td> {transItem.reg_date} </td>
                                                                <td> {parseInt(transItem.cart_amount_with_discount).toLocaleString()} </td>
                                                                <td>
                                                                    <a href="#!" style={{marginRight: '0'}} className="btn-details" title="جزئیات تراکنش" 
                                                                            onClick={() => showModalDetails(key)} >
                                                                        <i className="icon-info-circle" style={{fontSize: '24px'}} ></i>
                                                                    </a>
                                                                    <br />
                                                                    { profile.re_print === "1" ?
                                                                        <a href={`${PRINT_TRANS_EXTERNAL_LINK}${transItem.id}/${token}`} style={{marginRight: '0'}} title="پرینت"  target="_blank" >
                                                                            <i className="icon-printer4" style={{fontSize: '24px'}}></i>
                                                                        </a>
                                                                        :''
                                                                    }
                                                                    <br />
                                                                    {
                                                                        transItem.factor_num === null ?
                                                                        <a href="#!" style={{marginRight: '0'}} title="ویرایش شماره فاکتور"
                                                                                onClick={() => showModalEditFactorNum(key)} >
                                                                            <i className="icon-edit2" style={{fontSize: '24px'}}></i>
                                                                        </a>
                                                                        :''
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav aria-label="Page navigation" className="text-xs-center" style={{marginTop: '3%'}} >

                                    </nav>
                                </div>
                            </div>
                        </Col>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default Trans;